import {
  isISODateType,
  ISODateType,
  TypeGuard,
} from '@principle-theorem/shared';
import { isBoolean, isString } from 'lodash';

export enum MohHighCariesRequestReason {
  YearNine = 'yearNine',
  ExtendedPeriod = 'extendedPeriod',
  RecentlyEntered = 'recentlyEntered',
  RiskChanged = 'riskChanged',
}

export interface IMohHighCariesData {
  agreementNumber: string;
  patientLastName: string;
  patientFirstName: string;
  patientNhiNumber: string;
  practitionerName: string;
  requestReason: MohHighCariesRequestReason;
  dentinalToothStructure: boolean;
  teethBeenFissureSealed: boolean;
  teethRestored: boolean;
  previousExaminationDates?: string;
  notFissureSealedReason?: string;
  dateFissureSealed?: ISODateType;
  dateTeethRestored?: ISODateType;
  otherComments?: string;
}

export const isMohHighCariesData = TypeGuard.interface<IMohHighCariesData>({
  agreementNumber: isString,
  patientLastName: isString,
  patientFirstName: isString,
  patientNhiNumber: isString,
  practitionerName: isString,
  requestReason: TypeGuard.enumValue(MohHighCariesRequestReason),
  dentinalToothStructure: isBoolean,
  teethBeenFissureSealed: isBoolean,
  teethRestored: isBoolean,
  previousExaminationDates: TypeGuard.nilOr(isString),
  notFissureSealedReason: TypeGuard.nilOr(isString),
  dateFissureSealed: TypeGuard.nilOr(isISODateType),
  dateTeethRestored: TypeGuard.nilOr(isISODateType),
  otherComments: TypeGuard.nilOr(isString),
});
